import { useEffect, useState } from 'react'
import { Button, Modal, ModalFooter } from 'react-bootstrap'
import { getDepositAccountsUseCase } from '../../di/usecase_module'
import { GetDepositAccountsRequestDto } from '../../domain/usecases/balance/GetDepositAccountsUseCase'
import { DepositAccountComponent } from './DepositAccountComponent'
import { UIActions } from '../../presentation/redux/actions/UIActions'
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../presentation/redux/store/RootState';
import { DepositAccount } from '../../domain/models/DepositAccount';
import { applog } from '../../domain/utils/applog';
import jsPDF from 'jspdf';
import domtoimage from 'dom-to-image';

export const ModalDepositAccounts = () => {
  const [loadingBankAccounts, setLoadingBankAccounts] = useState(true);
  const [accounts, setAccounts] = useState<DepositAccount[]>([])

  const uiState = useSelector((s: RootState) => s.uiState);
  const dispatch = useDispatch();

  useEffect(() => {
    if (uiState.isDepositAccountsOpen) {
      setLoadingBankAccounts(true);
      getDepositAccountsUseCase()
        .execute(new GetDepositAccountsRequestDto())
        .then((result) => {
          setLoadingBankAccounts(false);
          setAccounts(result);
        }).catch((e) => {
          applog("Error ModalDepositAccounts ", e);
        })
    }
    return () => {
      setLoadingBankAccounts(true);
    }
  }, [uiState.isDepositAccountsOpen]);

  function handlePdf() {
    const input = document.getElementById('divToPrint');
    const pdf = new jsPDF('p');
    if (pdf && input) {

      let height = input.clientHeight;
      let width = input.clientWidth;
      let aspectRatio = height / (width + 20);
      let pdfWidth = 195;
      applog('Image', 'w', width);
      applog('Image', 'h', height);
      applog('Image', 'a', aspectRatio);
      applog('Image', 'hf', pdfWidth * aspectRatio);
      domtoimage.toPng(input)
        .then((imgData) => {
          pdf.addImage(imgData, 'PNG', 8, 0, pdfWidth, pdfWidth * aspectRatio);
          pdf.save('redsmart-cuentas.pdf');
        });
    }
  }

  function handleHide() {
    dispatch(UIActions.closeDepositAccounts());
  }

  return (
    <Modal
      onHide={handleHide}
      show={uiState.isDepositAccountsOpen}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered>

      <div id="divToPrint">
        <Modal.Header
          closeButton
          className="gradientBlue colorWhite">
          <Modal.Title id="contained-modal-title-vcenter">
            Cuentas bancarias
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {(loadingBankAccounts && !accounts.length) &&
            <p>Cargando información...</p>
          }
          {(!loadingBankAccounts && accounts.length === 0) && (
            <div className="no-accounts">
              <i className="fas fa-exclamation-triangle"></i>
              <p>No hay cuentas de depósito.</p>
            </div>
          )}
          {
            accounts.map((account) => {
              return <DepositAccountComponent key={account.id + account.accountNumber} account={account} />
            })
          }
        </Modal.Body>
      </div>
      <ModalFooter>
        <Button
          variant='accent'
          className='bgAccent colorWhite'
          onClick={handlePdf}>
          Imprimir
        </Button>
      </ModalFooter>
    </Modal>
  )
}

